// v2/utils/mapProduct.js — /api/products/ cevabini v2 urun sekline cevirir
//
// ONEMLI: mv_product_list'te "ank_stock" kolonu ISTANBUL deposunu tasiyor
// (view tanimi 'ANK'/'ANKARA'/'ISTANBUL' toplayor ama stok_info'da sadece
// GAZIANTEP ve ISTANBUL var). Bu yuzden ank_stock -> istanbulStock.

import { withVat } from './discount';

// OEM kodlari noktali virgul VEYA virgulle ayrilmis tek metin olarak geliyor
function oemAyir(metin) {
  if (!metin) return [];
  return String(metin)
    .split(/[;,]/)
    .map((s) => s.trim())
    .filter(Boolean);
}

// Urun gorselleri: /urun-gorsel/<KOD>/<KOD>_N.jpg
// Gorseli olmayan urunlerde nginx otomatik olarak temsili gorsele duser,
// bu yuzden istemcide "dosya var mi" kontrolu yapmiyoruz.
export const GORSEL_TABANI = '/urun-gorsel';
export const GORSEL_ADEDI = 4;

export function urunGorseli(kod, sira = 1) {
  const k = (kod || '').trim();
  if (!k) return null;
  return `${GORSEL_TABANI}/${encodeURIComponent(k)}/${encodeURIComponent(k)}_${sira}.jpg`;
}

export function urunGorselleri(kod) {
  const k = (kod || '').trim();
  if (!k) return [];
  return Array.from({ length: GORSEL_ADEDI }, (_, i) => urunGorseli(k, i + 1));
}

function sayi(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

// Kampanya oranlarini zincire cevirir.
// Backend tekil alan donduruyor (productCampaignRate vb.); ileride Vural'daki
// gibi cogul dizi eklenirse ikisi de desteklensin diye her ikisine de bakiyoruz.
function zincirKur(p) {
  const zincir = [];
  const ekle = (deger, tur, etiket) => {
    const liste = Array.isArray(deger) ? deger : [deger];
    liste.forEach((r) => {
      const oran = sayi(r);
      if (oran > 0) zincir.push({ rate: oran, kind: tur, label: etiket });
    });
  };
  ekle(p.productCampaignRates !== undefined ? p.productCampaignRates : p.productCampaignRate, 'customer', 'Ürün');
  ekle(p.groupCampaignRates !== undefined ? p.groupCampaignRates : p.groupCampaignRate, 'customer', 'Grup');
  ekle(p.generalProductCampaignRates !== undefined ? p.generalProductCampaignRates : p.generalProductCampaignRate, 'general', 'Genel Ürün');
  ekle(p.generalGroupCampaignRates !== undefined ? p.generalGroupCampaignRates : p.generalGroupCampaignRate, 'general', 'Genel Grup');
  return zincir;
}

export function mapProduct(p) {
  const brut = sayi(p.brut_price);
  const net = sayi(p.net_price);
  const fiyatVar = brut > 0;              // fiyatsiz urunlerde UI '-' gosterecek

  const zincir = zincirKur(p);
  const oranlar = zincir.map((d) => d.rate);

  const gzt = sayi(p.gzt_stock);
  const ist = sayi(p.ank_stock);          // ank_stock = ISTANBUL

  const kod = (p.code || '').trim();

  return {
    id: p.logicalref !== undefined && p.logicalref !== null ? String(p.logicalref) : p.code,
    image: urunGorseli(kod, 1),
    images: urunGorselleri(kod),
    brand: 'BOSCH',
    productCode: (p.code || '').trim(),
    description: p.name || p.product_name || '',
    groupCode: p.stgrpcode || '',
    group: p.stgrpcode || '',
    category: p.stgrpcode || '',
    oem: oemAyir(p.oem_codes),

    // Fiyatlar — fiyat yoksa null (UI '-' basacak)
    hasPrice: fiyatVar,
    grossPrice: fiyatVar ? brut : null,
    netPrice: fiyatVar ? net : null,
    vatPrice: fiyatVar ? withVat(net) : null,
    savingAmount: fiyatVar ? Math.max(brut - net, 0) : null,
    grossPriceEur: fiyatVar ? sayi(p.euro_brut_price) : null,
    netPriceEur: fiyatVar ? sayi(p.euro_net_price) : null,
    eurRate: sayi(p.euro_rate),

    // Indirim
    discounts: zincir,
    discountChain: oranlar,
    discountRate: fiyatVar && brut > 0 ? Math.round((1 - net / brut) * 10000) / 100 : 0,
    campaign: zincir.length > 0 ? { rate: oranlar[0] } : null,
    hasGeneralCampaign: zincir.some((d) => d.kind === 'general'),
    hasCustomerCampaign: zincir.some((d) => d.kind === 'customer'),

    // Stoklar
    gaziantepStock: gzt,
    istanbulStock: ist,
    totalStock: sayi(p.total_stock) || gzt + ist,

    lastUpdate: p.last_update || null,
  };
}

export function mapProducts(list) {
  return (Array.isArray(list) ? list : []).map(mapProduct);
}

export default mapProducts;
